import { Directive, ElementRef, AfterViewInit, OnDestroy, Output, EventEmitter, Input } from '@angular/core';
import * as $ from 'jquery';
import 'assets/vendor/select2/js/select2.js';
//import 'assets/vendor/select2/css/select2.css';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[appSelect2]'
})
export class Select2Directive implements AfterViewInit, OnDestroy {
    @Input() ngModel: string;
    @Input() placeholder: string;
    @Output() ngModelChange: EventEmitter<string> = new EventEmitter<string>();
    element: any;

    constructor(
        private elementRef: ElementRef,
        private control: NgControl
    ) { }


    ngOnDestroy(): void {
        //this.element.select2('destroy');
    }

    ngAfterViewInit(): void {
        this.element = $(this.elementRef.nativeElement);
        const abstractControl = this.control.control;
        this.element.select2({
            //placeholder: this.placeholder,
            placeholder: "Select",
            width: 'resolve',
            tags: true,
            allowClear: true
        }).on('select2:select', function (e) {
            var data = e.params.data;
            abstractControl.patchValue(data.id);
            //this.ngModelChange.emit(data.id);
        });
    }
}
